module.exports = __webpack_public_path__ + "static/img/9127_phase_function_Paper_PointsHejduk_Prediction.3c38267.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/9127_phase_function_Paper_PointsHejduk_Prediction.png
// module id = tU7p
// module chunks = 0